import { render, staticRenderFns } from "./ViewCourseScheduling.vue?vue&type=template&id=828d28b4"
import script from "./ViewCourseScheduling.vue?vue&type=script&lang=js"
export * from "./ViewCourseScheduling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports